import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  ConflictReason,
  ConflictReasonColors,
  ConflictReasonIcons,
  ConflictReasonLabels,
} from "../../../../models/ConflictReason";
import {
  MigrationFlagStatus,
  ConflictStatusColors,
  ConflictStatusLabels,
} from "../../../../models/Flags/MigrationFlagStatus";

interface FileConflictChipProps {
  conflictReason: ConflictReason | null;
  conflictStatus: MigrationFlagStatus | null;
}

/**
 * Renders the SharePoint conflict state (reason + status) as a pair of badges.
 * Shows nothing when the file has no conflict (conflictStatus is null).
 */
export const FileConflictChip: React.FC<FileConflictChipProps> = ({
  conflictReason,
  conflictStatus,
}) => {
  if (conflictStatus == null) return null;

  const ReasonIcon = conflictReason ? ConflictReasonIcons[conflictReason] : undefined;

  return (
    <div className="flex flex-col items-start gap-1">
      {conflictReason && (
        <Badge variant={ConflictReasonColors[conflictReason]}>
          {ReasonIcon && <ReasonIcon className="size-3" />}
          {ConflictReasonLabels[conflictReason]}
        </Badge>
      )}
      <Badge variant={ConflictStatusColors[conflictStatus]}>
        {ConflictStatusLabels[conflictStatus]}
      </Badge>
    </div>
  );
};
